import React, { Component } from 'react';

import ThermocyclerOpen from '../../img/thermocycler-open.svg'
import ThermocyclerClosed from '../../img/thermocycler-closed.svg'

const images = {
  "thermocycler-closed": ThermocyclerClosed,
  "thermocycler-open": ThermocyclerOpen
}

export class Graphics extends Component {

  getImage = () => {
    var ref = 'thermocycler-'
    if (!this.props.open) {
      ref += 'closed'
    } else {
      ref += 'open'
    }

    return images[ref]

  };

  render(){
    return(
      <div
        aria-label="Thermocycler"
        className="graphics"
      >
        <img
          style={{ pointerEvents: "none" }}
          src={this.getImage()}
          alt={"Thermocycler"}
        />
      </div>
    )
  }
}
